import styled from 'styled-components';
import { Button } from '@insurancemenu/imenu-components-lib';

export const NoPlansSectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;
`;

export const NoPlansSectionTitleStyled = styled.h3`
  font-size: 2rem;
  text-align: center;
  line-height: 3.4rem;

  @media (width <= 900px) {
    font-size: 1.6rem;
    margin-top: 0;
  }
`;

export const NoPlansBrowseButtonStyled = styled(Button)`
  margin: 2.8rem auto 0;
  min-width: 25rem;
`;
